import { render } from "./home.vue?vue&type=template&id=a35d65aa"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=a35d65aa&lang=postcss"
script.render = render

export default script